import api from "@/services/api.service";

export default {
 name: 'response-contact',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Imported Contact list"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    icon: 'fa fa-sort',
    selcol: '',
    items: [],
    items_new: [],
    // items_merged: [],
    fields: [
    { key: "#", sortable:false },
    { key: "actions", sortable:false, stickyColumn: true, },
    { key: "score", sortable:false },
    { key: "status", sortable:false }],
    // fieldsMerged:[],
    sech: {},
    currentPage: 1,
    currentPageNew: 1,
    // currentMergedPage: 1,
    currentSortDir:'desc',        
    perPage: 10,
    perPageNew: 10,
    // perPageMerged: 10,
    totalRows: null,
    totalResponseContact: 0,
    totalResponseContactNew: 0,
    // totalMergedContact: 0,
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    isApproved : true,
    allSelectedNew: false,
    conflict_cnt:'',
    colName : '',
    permission_importedList: false,
    permission_viewConflict: false,
    permission_deleteImportedContact: false,
    superAdmin: false,
    exists : null,
    pageOptionsConflict:[{
          text: '10', value: '10',
      }, {
          text: '50', value: '50'
      }, {
          text: '100', value: '100',
      }, {
          text: '250', value: '250',
      }, {
          text: '500', value: '500',
      }],
    pageOptionsNew:[{
          text: '10', value: '10',
      }, {
          text: '50', value: '50'
      }, {
          text: '100', value: '100',
      }, {
          text: '250', value: '250',
      }, {
          text: '500', value: '500',
      }],
      // pageOptionsMerged:[{
      //   text: '10', value: '10',
      // }, {
      //     text: '50', value: '50'
      // }, {
      //     text: '100', value: '100',
      // }, {
      //     text: '250', value: '250',
      // }, {
      //     text: '500', value: '500',
      // }],
  };
},
computed: {},
mounted() {},
async created() {
  let response = await api.post("users/user-permissions");
        const permissions = [];
        if (response.status == "success") {
          response.data[0].permission.forEach( function(element) {                
              permissions.push(element.action)
          }.bind(this));
            if(permissions.includes("list_imported_contact") == true){
              this.getImportedContacts();
              this.getImportedContactsNew();
              // this.getMergedContacts();
              this.permission_importedList = permissions.includes("list_imported_contact");
              this.permission_viewConflict = permissions.includes("view_conflict_imported_contact");
              this.permission_deleteImportedContact = permissions.includes("delete_imported_contact");
            }else if(response.data[0].role == 'super_admin'){
              this.getImportedContacts();
              this.getImportedContactsNew();
              // this.getMergedContacts();
              this.superAdmin = true;
          }else if(permissions.includes("list_import_contact") == true || permissions.includes("add_import_contact") == true){
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Import Contact List'});
            }else{
                this.makeToast("Permission denied","Alert","warning",6000);
                this.$router.push({name: 'Admin Dashboard'});
            }
        }  
},
watch: {
  currentPage: {
    handler: function(page) {         
        // this.getImportedContacts(page)
        this.toSort(this.colName,page); 
    }
  },
  currentPageNew: {
    handler: function(page) {         
        // this.getImportedContactsNew(page);
        this.toSortNew(this.colName,page); 
    }
  },
  // currentMergedPage: {
  //   handler: function(page) {         
  //       this.getMergedContacts(page);
  //   }
  // }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  selectAll: function(e) {
    this.delete_ids = [];            
    if(e.target.checked){
      for (var item in this.items) {
        this.delete_ids.push(this.items[item].id.toString());
      }                
    }            
  },
  selectAllNew: function(e) {
    this.delete_ids = [];            
    if(e.target.checked){
      for (var item in this.items_new) {
        this.delete_ids.push(this.items_new[item].id.toString());
      }                
    }            
  },
  selectOne(){
    this.allSelected = false;            
  },
  selectOneNew(){
      this.allSelectedNew = false;            
    },
  async toSort(items,page = 1) {
    if (items != "actions" && items != "#") {                    
    this.items = [];

    if(page == 1)
    if(items == this.colName)
    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';

    this.colName = items;
    this.sech.page = page;
    this.sech.import_contact_id = this.$route.params.id;
    this.isBusy=true;
    let response = await api.post("admin/import-contact/imported-contact-list", { page:page,columnname:items,sortType:this.currentSortDir,import_contact_id:this.sech.import_contact_id,paginateVal:this.perPage });
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        if(this.currentSortDir == 'asc'){
            this.icon1 = 'fa fa-sort-up';                             
            this.selcol = items;        
        } else{ 
            this.icon1 = 'fa fa-sort-down';                             
            this.selcol = items;
        }  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

        columns.splice(0,0);
        columns.map((h) => {
          this.fields.push({key: h, sortable: false}) 
        });

        //Iterate Data 
        response.data.records.data.forEach( function(element) {
          var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status,conflict_score:element.highScore} )
          this.items.push(someObject);  
        }.bind(this));

        this.conflict_cnt = response.data.conflict_cnt;        
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  }
  },
  async getImportedContacts(page) {
    this.items = [];
    this.sech.page = page;
    this.sech.import_contact_id = this.$route.params.id;
    let response = await api.post("admin/import-contact/imported-contact-list", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element) {
          var someObject = Object.assign({}, JSON.parse(element.contact_data), {id:element.id,status:element.status,conflict_score:element.highScore} )
          this.items.push(someObject);  
        }.bind(this));

        this.conflict_cnt = response.data.conflict_cnt;        
        this.totalResponseContact = response.data.records.total;        
        this.currentPage = response.data.records.current_page;
        this.perPage = response.data.records.per_page;

        // this.pageOptionsConflict = this.pageOptions;
        this.pageOptionsConflict.forEach(element => {
          if(element.value > this.totalResponseContact){
              var indexOf = this.pageOptionsConflict.indexOf(element);
              if( indexOf != 0 )
              this.pageOptionsConflict.splice(indexOf)
          }
        });
        if(this.totalResponseContact <= 500)
        this.pageOptionsConflict.push({text:'All',value:this.totalResponseContact});
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },
  async toSortNew(items_new,page = 1) {
    if (items_new != "actions"  && items_new != "score" && items_new != "#") {                    
    this.items_new = [];

    if(page == 1)
    if(items_new == this.colName)
    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';

    this.colName = items_new;
    this.sech.page = page;
    this.sech.import_contact_id = this.$route.params.id;
    this.isBusy = true;    
    let response = await api.post("admin/import-contact/imported-contact-list-new", { page:page,columnname:items_new,sortType:this.currentSortDir,import_contact_id:this.sech.import_contact_id,paginateVal:this.perPageNew });
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        if(this.currentSortDir == 'asc'){
            this.icon1 = 'fa fa-sort-up';                             
            this.selcol = items_new;        
        } else{ 
            this.icon1 = 'fa fa-sort-down';                             
            this.selcol = items_new;
        }  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element1) {                    
          if(element1.status == 'New'){
            var someObject1 = Object.assign({}, JSON.parse(element1.contact_data), {id:element1.id,status:element1.status} )
            this.isApproved = (element1.resolution == 'new' ? true : false );
            this.items_new.push(someObject1); 
          } 
        }.bind(this));

        this.totalResponseContactNew = response.data.records.total;        
        this.currentPageNew = response.data.records.current_page;
        this.perPageNew = response.data.records.per_page;
      } else {
        this.items_new = [];
      }
    }      
    this.isBusy = false;
  }
  },
  async getImportedContactsNew(page) {
    this.items_new = [];
    this.sech.page = page;
    this.sech.import_contact_id = this.$route.params.id;
    let response = await api.post("admin/import-contact/imported-contact-list-new", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.records.data != "") {  
        //GET ALL HEADERS FROM JSON        
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));

        columns.splice(0,0);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
       });

        //Iterate Data 
        response.data.records.data.forEach( function(element1) {                    
          if(element1.status == 'New'){
            var someObject1 = Object.assign({}, JSON.parse(element1.contact_data), {id:element1.id,status:element1.status} )
            this.isApproved = (element1.resolution == 'new' ? true : false );
            this.items_new.push(someObject1); 
          } 
        }.bind(this));

        this.totalResponseContactNew = response.data.records.total;        
        this.currentPageNew = response.data.records.current_page;
        this.perPageNew = response.data.records.per_page;

        // this.pageOptionsNew = this.pageOptions;
        this.pageOptionsNew.forEach(e => {
          if(e.value > this.totalResponseContactNew){
              var indexOf1 = this.pageOptionsNew.indexOf(e);
              if( indexOf1 != 0 )
              this.pageOptionsNew.splice(indexOf1)
          }
        });
        if(this.totalResponseContactNew <= 500)
        this.pageOptionsNew.push({text:'All',value:this.totalResponseContactNew});
      } else {
        this.items_new = [];
      }
    }      
    this.isBusy = false;
  },
  // async getMergedContacts(page) {
  //   this.items_merged = [];
  //   this.sech.page = page;
  //   this.sech.paginateVal = this.perPageMerged;
  //   let response = await api.post("admin/import-contact/imported-contact-list-merged", this.sech);
  
  //   if (response.status == "success") {
  //     if (response.data.records.data != "") {  
  //       var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.records.data[0].contact_data)]));
  //       columns.splice(0,0);
  //       columns.map((h) => {
  //         this.fieldsMerged.push({key: h, sortable: true}) 
  //       });

  //       //Iterate Data 
  //       response.data.records.data.forEach( function(element1) {                    
  //           var someObject2 = Object.assign({}, JSON.parse(element1.contact_data))
  //           this.items_merged.push(someObject2); 
  //       }.bind(this));

  //       this.totalMergedContact = response.data.records.total;
  //       this.currentMergedPage = response.data.records.current_page;
  //       this.perPageMerged = response.data.records.per_page;
        
  //       this.pageOptionsMerged.forEach(element => {
  //         if(element.value > this.totalMergedContact){
  //           var indexOf = this.pageOptionsMerged.indexOf(element);
  //             if( indexOf != 0 )
  //             this.pageOptionsMerged.splice(indexOf)
  //         }
  //       });
  //       if(this.totalMergedContact <= 500)
  //       this.pageOptionsMerged.push({text:'All',value:this.totalMergedContact});
  //     } else {
  //       this.items_merged = [];
  //       this.fieldsMerged = [];
  //     }
  //   }
  //   this.isBusy = false;

  // },
  getRowCount(items) {    
    return items.length;
  },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event response Contacts?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event response Contact?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteMarketingContact(id, index) {

    let response = await api.post("admin/import-contact/delete-imported-contact-list",
      { id: id , import_contact_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.allSelected = false;
        this.allSelectedNew = false;            
        this.getImportedContacts();
        this.getImportedContactsNew();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Imported contacts delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Imported contacts not deleted.`, "Alert", "danger");
  },
 async showConflict(id){    
    return this.$router.push({name : "Imported Contact Conflict",params: {conflict_id:id}});
  },
  async approveNewContacts(){

    let response = await api.post("admin/import-contact/approve-new-contacts",{import_contact_id : this.$route.params.id });
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {
      this.isApproved = true;
      this.makeToast(`New contacts approved successful.`,"Alert","success");
    } else{
      for (var error in response.errors)
        this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
    } 
  }
}
};
